import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ie11Mixin, lineHeightMixin, Text } from '@zillow/constellation';

const ClampedText = styled(Text)`
  /* https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.maxLines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: normal;
  overflow-wrap: break-word;
  ${ie11Mixin(css`
    /* This implementation is a little buggy in foundation, due to it considering the fontType mobile */
    /* So, we restrict this implementation to IE11 */
    max-height: ${(props) => css`
      ${lineHeightMixin(props.fontType, (lineHeight) => lineHeight.value * props.maxLines)}px
    `};
    word-break: break-word;
    overflow: hidden;
    display: inline-block;
  `)}
`;

ClampedText.propTypes = {
  maxLines: PropTypes.number.isRequired,
  fontType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      default: PropTypes.string,
      lg: PropTypes.string,
    }),
  ]).isRequired,
};

export default ClampedText;
